import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CARD_CATEGORIES } from '@/lib/utils/constants/cards';
import { useEffect } from 'react';
import { CardTypeOption } from '@/lib/utils/constants/cards';

interface FieldValues {
  [key: string]: string;
}

interface FieldSelectorProps {
  selectedCategory: string;
  fieldValues: FieldValues;
  onFieldValueChange: (field: string, value: string) => void;
}

export function FieldSelector({
  selectedCategory,
  fieldValues,
  onFieldValueChange,
}: FieldSelectorProps) {
  if (!selectedCategory) return null;

  // Ensure there's a value selected for each field
  useEffect(() => {
    Object.entries(CARD_CATEGORIES[selectedCategory].fields).forEach(([field, values]) => {
      if (values.length > 0 && !fieldValues[field]) {
        const firstValue = values[0];
        onFieldValueChange(field, typeof firstValue === 'string' ? firstValue : firstValue.name);
      }
    });
  }, [selectedCategory, fieldValues]);

  const getValue = (value: string | CardTypeOption): string => {
    return typeof value === 'string' ? value : value.name;
  };

  const getDisplayValue = (value: string | CardTypeOption): string => {
    return typeof value === 'string' ? value : value.name;
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Fields</h3>
      <div className="grid gap-4">
        {Object.entries(CARD_CATEGORIES[selectedCategory].fields).map(([field, values]) => (
          <div key={field} className="flex gap-4 items-center">
            <span className="min-w-24 text-sm font-medium">{field}:</span>
            <Select
              value={fieldValues[field] || getValue(values[0])}
              onValueChange={(value) => onFieldValueChange(field, value)}
            >
              <SelectTrigger className="flex-1">
                <SelectValue placeholder={`Select ${field}`} />
              </SelectTrigger>
              <SelectContent>
                {values.map((value) => (
                  <SelectItem 
                    key={getValue(value)} 
                    value={getValue(value)}
                  >
                    {getDisplayValue(value)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
} 